export default __webpack_public_path__ + "static/media/Dark Blue Logo.3da6b2f1.png";